import { render, staticRenderFns } from "./billing-file-import.vue?vue&type=template&id=8b5f1a28&"
import script from "./billing-file-import.vue?vue&type=script&lang=js&"
export * from "./billing-file-import.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports